module.exports = __webpack_public_path__ + "img/img25.1e3ad453.jpg";